import styled from 'styled-components'

import Button from './Button'
import ResponsiveImage from './ResponsiveImage'

const Wrapper = styled.div<{
  taller?: boolean
}>`
  position: relative;

  width: 100%;
  height: 300px;

  padding: 20px;

  @media (min-width: 768px) {
    padding: 40px;
  }

  background-color: #333;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (min-width: 768px) {
    height: ${({ taller }) => (taller ? '600px' : '500px')};
  }
`

const Content = styled.div`
  position: relative;

  display: flex;
  align-items: flex-end;
  justify-content: flex-end;

  width: 100%;
  height: 100%;
`

const ActionButton = styled(Button)`
  color: #333 !important;
  background-color: rgba(255, 255, 255, 0.9);
  transition: background-color 300ms ease-out;
  &:hover {
    background-color: white;
  }
`

interface GalleryHeaderProps {
  backgroundImage?: Omit<GQL_PhotoImage, '__typename'>
  photos?: Pick<GQL_Photo, 'image'>[]
  videos?: Array<{ id: string; streamUrl: string; thumbnailUrl: string }>
  taller?: boolean
  onOpen?: (...args: any) => any
}

const GalleryHeader = ({
  backgroundImage,
  photos = [],
  videos = [],
  taller,
  onOpen,
}: GalleryHeaderProps) => {
  const content = [...photos, ...videos]

  const medium = backgroundImage?.medium
  const large = backgroundImage?.large

  return (
    <Wrapper taller={taller}>
      <ResponsiveImage
        medium={medium}
        large={large}
        preload
        style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}
      />
      <Content>
        {onOpen && content?.length > 1 && (
          <ActionButton className="action-button" onClick={onOpen} white>
            Photos
          </ActionButton>
        )}
      </Content>
    </Wrapper>
  )
}

export default GalleryHeader
